import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { TyreDiscount, TyreDiscountCategory } from "models";

const component = "TyreDiscountsDashboard";

export const TyreDiscountsDashboardQueryKeys = {
  discounts: backendQueryKey<TyreDiscount[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/tyre_discounts/list_discounts" }),
  categories: backendQueryKey<TyreDiscountCategory[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/tyre_discounts/list_categories" }),
  tyreBrands: permanentBackendQueryKey<string[]>({ component, endpoint: "/tyres/brands/list", baseUrl: ENV.carBaseURL }),
  tyreTeamBrands: permanentBackendQueryKey<string[]>({ component, endpoint: "/catalog/brands/list", baseUrl: ENV.tyreTeamBaseURL })
};
